import { ResponseException } from "../../../../Exceptions";
import { request } from "../../api";


export async function getReport(docId) {
    const response = await request("/data/sameday/report", { query: { id: docId } });
    if(response.ok) return response.data;
    
    throw new ResponseException(response);
}

export async function getReportDraft({ month, year, lgu }) {
    const response = await request("/data/sameday/report/draft", { query: { lgu, month, year } });
    if(response.ok) return response.data;
    
    throw new ResponseException(response);
}


export async function getReportHistory(docId) {
    const response = await request("/data/sameday/report/history", { query: { id: docId } });
    if(response.ok) return response.data;
    
    throw new ResponseException(response);
}


export async function updateReport({ docId, attractions }) {
    const response = await request("POST /data/sameday/report/", 
        { query: { id: docId }, body: { attractions } });
        
    if(response.ok) return response.data;
    
    throw new ResponseException(response);
}

export async function updateReportDraft({ lgu, month, year, attractions }) {
    const response = await request("POST /data/sameday/report/draft/", 
        { query: { lgu, month, year }, body: { attractions } });
        
    if(response.ok) return response.data;
    
    throw new ResponseException(response);
}

export async function submitReport({ docId, remarks }) {
    const response = await request("POST /data/sameday/report/submit/", 
        { query: { id: docId }, body: { remarks } });
        
    if(response.ok) return response.data;
    
    throw new ResponseException(response);
}

export async function approveReport({ docId, remarks }) {
    const response = await request("POST /data/sameday/report/approve/", 
        { query: { id: docId }, body: { remarks } });
        
    if(response.ok) return response.data;
    
    throw new ResponseException(response);
}

export async function returnReport({ docId, remarks, target }) {
    const response = await request("POST /data/sameday/report/return/", 
        { query: { id: docId, target }, body: { remarks } });
        
    if(response.ok) return response.data;
    
    throw new ResponseException(response);
}

export async function unpublishReport({ docId }) {
    const response = await request("POST /data/sameday/report/unpublish/", 
        { query: { id: docId }});
        
    if(response.ok) return response.data;
    
    throw new ResponseException(response);
}

export async function deleteReport(docId) {
    const response = await request("DELETE /data/sameday/report/", 
        { query: { id: docId } });
        
    if(response.ok) return response.data;
    
    throw new ResponseException(response);
}